import React from 'react';
import PropTypes from 'prop-types';
import AppLoader from '@tenant/core/AppLoader';

const AppSuspense = (
  props = {
    loadingProps: {
      delay: 300,
    },
  },
) => {
  return (
    <>
      <React.Suspense fallback={<AppLoader />}>{props.children}</React.Suspense>
    </>
  );
};

AppSuspense.propTypes = {
  loadingProps: PropTypes.object,
};

export default AppSuspense;

AppSuspense.propTypes = {
  children: PropTypes.node.isRequired,
};
